import { useState } from 'react';
import { NAVY, GOLD, WHITE, fmt, STATUS_COLORS, PRIORITY_COLORS } from '../lib/ui';
import { Pill, Empty, Select } from '../lib/ui';

const DONE = ['Completed', 'Closed'];

export default function ArchiveView({ matters, allTasks, team, setActiveMatter, setActiveTask, setView }) {
  const [tab,    setTab]    = useState('matters');
  const [search, setSearch] = useState('');

  const memberName = id => team.find(m => m.id === id)?.name || '—';

  const doneMAtters = matters.filter(m => DONE.includes(m.status));
  const doneTasks   = allTasks.filter(t => DONE.includes(t.status));

  const filteredMatters = doneMAtters.filter(m =>
    !search || m.name.toLowerCase().includes(search.toLowerCase()) || m.client.toLowerCase().includes(search.toLowerCase())
  );
  const filteredTasks = doneTasks.filter(t =>
    !search || t.title.toLowerCase().includes(search.toLowerCase()) || t.matterName.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div style={{ display:'flex', flexDirection:'column', gap:16 }}>

      {/* Header */}
      <div style={{ background:WHITE, borderRadius:10, border:'1px solid #E5E0D8', padding:'16px 20px', display:'flex', alignItems:'center', gap:16 }}>
        <div style={{ fontSize:28 }}>🗂️</div>
        <div>
          <div style={{ fontFamily:'Georgia,serif', fontSize:18, fontWeight:700, color:NAVY }}>Archive</div>
          <div style={{ fontSize:12, color:'#888', marginTop:2 }}>
            {doneMAtters.length} completed matter{doneMAtters.length!==1?'s':''} · {doneTasks.length} completed task{doneTasks.length!==1?'s':''}
          </div>
        </div>
      </div>

      {/* Search */}
      <input
        value={search} onChange={e => setSearch(e.target.value)}
        placeholder="Search archived matters and tasks…"
        style={{ border:'1px solid #D0CBBF', borderRadius:8, padding:'10px 14px', fontSize:14, background:'#FAFAF8', fontFamily:'inherit', outline:'none' }}
      />

      {/* Tabs */}
      <div style={{ display:'flex', borderBottom:'1px solid #E5E0D8' }}>
        {[
          { key:'matters', label:`Completed Matters (${filteredMatters.length})` },
          { key:'tasks',   label:`Completed Tasks (${filteredTasks.length})` },
        ].map(tb => (
          <button key={tb.key} onClick={() => setTab(tb.key)} style={{
            padding:'10px 22px', border:'none', background:'none', cursor:'pointer',
            fontSize:13, fontWeight:tab===tb.key?700:400, color:tab===tb.key?NAVY:'#888',
            fontFamily:'inherit', borderBottom:tab===tb.key?`2px solid ${GOLD}`:'2px solid transparent',
          }}>{tb.label}</button>
        ))}
      </div>

      {/* Completed Matters */}
      {tab === 'matters' && (
        <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
          {filteredMatters.length === 0 && <Empty text="No completed matters yet." />}
          {filteredMatters.map(m => (
            <div key={m.id} onClick={() => { setActiveMatter(m.id); setView('matters'); }}
              style={{ background:WHITE, borderRadius:8, border:'1px solid #E5E0D8', padding:'14px 18px', cursor:'pointer', display:'flex', alignItems:'center', gap:14 }}
              onMouseEnter={e => e.currentTarget.style.boxShadow='0 2px 12px rgba(27,42,74,0.08)'}
              onMouseLeave={e => e.currentTarget.style.boxShadow='none'}>
              <div style={{ width:36, height:36, borderRadius:'50%', background:'#EAF7EE', display:'flex', alignItems:'center', justifyContent:'center', fontSize:18, flexShrink:0 }}>✅</div>
              <div style={{ flex:1, minWidth:0 }}>
                <div style={{ fontSize:14, fontWeight:700, color:NAVY, marginBottom:4 }}>{m.name}</div>
                <div style={{ fontSize:12, color:'#888' }}>
                  {m.client} · {(m.tasks||[]).length} tasks · Deadline: {fmt(m.deadline)}
                </div>
              </div>
              <div style={{ display:'flex', gap:8, flexShrink:0, alignItems:'center' }}>
                <Pill label={m.status} color={STATUS_COLORS[m.status]} size={11} />
                <span style={{ fontSize:12, color:'#CCC' }}>→</span>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Completed Tasks */}
      {tab === 'tasks' && (
        <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
          {filteredTasks.length === 0 && <Empty text="No completed tasks yet." />}
          {filteredTasks.map(t => (
            <div key={t.id}
              onClick={() => { setActiveMatter(t.matter_id); setTimeout(() => setActiveTask(t.id), 80); setView('matters'); }}
              style={{ background:WHITE, borderRadius:8, border:'1px solid #E5E0D8', padding:'14px 18px', cursor:'pointer', display:'flex', alignItems:'center', gap:14 }}
              onMouseEnter={e => e.currentTarget.style.boxShadow='0 2px 12px rgba(27,42,74,0.08)'}
              onMouseLeave={e => e.currentTarget.style.boxShadow='none'}>
              <div style={{ width:36, height:36, borderRadius:'50%', background:'#EAF7EE', display:'flex', alignItems:'center', justifyContent:'center', fontSize:18, flexShrink:0 }}>✅</div>
              <div style={{ flex:1, minWidth:0 }}>
                <div style={{ fontSize:14, fontWeight:700, color:NAVY, marginBottom:4 }}>{t.title}</div>
                <div style={{ fontSize:12, color:'#888' }}>
                  {t.matterName} · {(t.assignees||[]).map(memberName).join(', ')} · {fmt(t.deadline)}
                </div>
              </div>
              <div style={{ display:'flex', gap:8, flexShrink:0, alignItems:'center' }}>
                <Pill label={t.status} color={STATUS_COLORS[t.status]} size={11} />
                <span style={{ fontSize:12, color:'#CCC' }}>→</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
